(function (global) {
  'use strict';

  var selector = '[data-tlt-product-price]';

  function priceRoots(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return [];
    var roots = Array.from(root.querySelectorAll(selector));
    if (typeof root.matches === 'function' && root.matches(selector)) roots.unshift(root);
    return roots;
  }

  function refresh(root, host) {
    host = host || global;
    var api = host.TLTCurrency;
    if (!api || typeof api.currencyContext !== 'function' || typeof api.formatManagedPrices !== 'function') return;
    priceRoots(root).forEach(function (price) {
      var source = price.getAttribute('data-tlt-money-source');
      if (!/^[A-Z]{3}$/.test(source || '')) return;
      // Metadata remains in Shopify's native currency; only displayed text changes.
      // A failed converter therefore retains a useful native-currency fallback.
      try {
        api.formatManagedPrices(price, api.currencyContext(source, host), {
          sourceCurrency: source,
          locale: host.document && host.document.documentElement.lang || 'en-GB',
          host: host
        });
      } catch (_) {
        // A rate probe can succeed while conversion of a particular amount fails.
        // Restore cached native markup instead of retaining an old display currency.
        try {
          api.formatManagedPrices(price, api.currencyContext(source, {}), {
            sourceCurrency: source,
            locale: host.document && host.document.documentElement.lang || 'en-GB',
            host: host
          });
        } catch (_) { /* Do not affect the product form or option selection. */ }
      }
    });
  }

  function start(host) {
    var doc = host.document;
    if (!doc || host.__tltProductCurrencyStarted) return;
    host.__tltProductCurrencyStarted = true;
    var scheduled = false;
    var queue = function () {
      if (scheduled) return;
      scheduled = true;
      host.setTimeout(function () { scheduled = false; refresh(doc, host); }, 0);
    };
    refresh(doc, host);
    doc.addEventListener('on:variant:change', queue);
    doc.addEventListener('shopify:section:load', queue);
    if (host.MutationObserver) {
      var observer = new host.MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          if (record.type === 'attributes') return true;
          // Ignore the formatter's own text-node replacements. Only newly mounted
          // managed price roots need discovery; variant amounts use attributes.
          return Array.from(record.addedNodes || []).some(function (node) {
            return node.nodeType === 1 && priceRoots(node).length > 0;
          });
        });
        if (relevant) queue();
      });
      observer.observe(doc.body, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['doubly-currency', 'data-tlt-money-amount', 'data-tlt-money-currency']
      });
    }
    // The currency app can initialize late or change its selection without an event.
    host.setInterval(function () { refresh(doc, host); }, 1000);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { refresh: refresh, priceRoots: priceRoots, start: start };
  if (global.document) {
    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', function () { start(global); }, { once: true });
    else start(global);
  }
})(typeof window !== 'undefined' ? window : globalThis);
